/* ==========================================================================
   Plant Store <> UnfoldCRO — related product tabs

   Tab one is Shopify's recommendations (rendered server-side into
   <product-recommendations>). Tab two is recently-viewed, which has no
   server-side source — the handles are kept in localStorage here and their
   cards fetched from each product page's own related section.

   The tab hides itself until there is something to show, so it never
   presents an empty panel.
   ========================================================================== */
(function () {
  'use strict';

  if (window.ufcRelatedBound) return;
  window.ufcRelatedBound = true;

  var KEY = 'ufc-recently-viewed';
  var MAX = 12;

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function remember(handle) {
    if (!handle) return;
    try {
      var list = read().filter(function (item) {
        return item !== handle;
      });
      list.unshift(handle);
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      /* private mode — recently viewed just stays empty */
    }
  }

  function init() {
    var root = document.querySelector('[data-ufc-rel]');
    if (!root) return;

    var current = root.dataset.productHandle;
    var limit = parseInt(root.dataset.limit, 10) || 4;

    var tabs = root.querySelectorAll('[data-ufc-rel-tab]');
    var panels = root.querySelectorAll('[data-ufc-rel-panel]');

    Array.prototype.forEach.call(tabs, function (tab) {
      tab.addEventListener('click', function () {
        var name = tab.dataset.ufcRelTab;
        Array.prototype.forEach.call(tabs, function (other) {
          var on = other === tab;
          other.classList.toggle('is-active', on);
          other.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        Array.prototype.forEach.call(panels, function (panel) {
          panel.hidden = panel.dataset.ufcRelPanel !== name;
        });
      });
    });

    // Everything except this product, newest first.
    var handles = read()
      .filter(function (handle) {
        return handle && handle !== current;
      })
      .slice(0, limit);

    if (handles.length) {
      var target = root.querySelector('[data-ufc-rel-viewed]');
      var tab = root.querySelector('[data-ufc-rel-tab="viewed"]');

      // Each product page renders this same section, so its own card markup
      // can be lifted straight out of it.
      Promise.all(
        handles.map(function (handle) {
          // sections/ufc-card renders just that product's own card. Asking its
          // product page for the related section would return that product's
          // recommendations instead — a different product entirely.
          return fetch('/products/' + handle + '?section_id=ufc-card')
            .then(function (response) {
              return response.ok ? response.text() : '';
            })
            .then(function (text) {
              if (!text) return null;
              var parsed = new DOMParser().parseFromString(text, 'text/html');
              var card = parsed.querySelector('.ufc-rel__cell');
              return card ? card.outerHTML : null;
            })
            .catch(function () {
              return null;
            });
        })
      ).then(function (cards) {
        var html = cards.filter(Boolean).join('');
        if (!html || !target || !tab) return;
        target.innerHTML = html;
        tab.hidden = false;
      });
    }

    remember(current);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
